module.exports = __webpack_public_path__ + "103c5fd6254183d4e3ba261dc84000ba.svg";